// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchUser_searchBar__6BNdb"};